// Comprehensive ISO-3166 alpha-2 country list with E.164 calling codes.
// Source: ITU-T E.164 assignments + Unicode CLDR. Used by IdentitySheet's
// searchable country picker so any user worldwide can link their WhatsApp
// history. Backend validation goes through Google libphonenumber — this
// list is purely for the UI selector.
//
// Order: cricket-playing nations + diaspora hubs first (for fast pick),
// then the rest alphabetical by name. Search matches name OR dial code.

export const PRIORITY_CODES = new Set([
  "IN", "IE", "GB", "US", "CA", "AU", "NZ", "ZA", "AE", "PK",
  "LK", "BD", "SG", "MY", "QA", "SA", "KW", "OM", "BH", "KE",
  "NG", "ZW", "WI", "AF", "NP",
]);

// Each entry: {code, dial, flag, name}. Flag emojis are Regional Indicator
// pairs (RIS) — render natively on iOS/Android, fall back to text on
// some Windows/Linux Chrome builds (acceptable — country code + name still
// readable).
export const COUNTRIES = [
  { code: "AF", dial: "+93",   flag: "🇦🇫", name: "Afghanistan" },
  { code: "AL", dial: "+355",  flag: "🇦🇱", name: "Albania" },
  { code: "DZ", dial: "+213",  flag: "🇩🇿", name: "Algeria" },
  { code: "AS", dial: "+1684", flag: "🇦🇸", name: "American Samoa" },
  { code: "AD", dial: "+376",  flag: "🇦🇩", name: "Andorra" },
  { code: "AO", dial: "+244",  flag: "🇦🇴", name: "Angola" },
  { code: "AI", dial: "+1264", flag: "🇦🇮", name: "Anguilla" },
  { code: "AG", dial: "+1268", flag: "🇦🇬", name: "Antigua and Barbuda" },
  { code: "AR", dial: "+54",   flag: "🇦🇷", name: "Argentina" },
  { code: "AM", dial: "+374",  flag: "🇦🇲", name: "Armenia" },
  { code: "AW", dial: "+297",  flag: "🇦🇼", name: "Aruba" },
  { code: "AU", dial: "+61",   flag: "🇦🇺", name: "Australia" },
  { code: "AT", dial: "+43",   flag: "🇦🇹", name: "Austria" },
  { code: "AZ", dial: "+994",  flag: "🇦🇿", name: "Azerbaijan" },
  { code: "BS", dial: "+1242", flag: "🇧🇸", name: "Bahamas" },
  { code: "BH", dial: "+973",  flag: "🇧🇭", name: "Bahrain" },
  { code: "BD", dial: "+880",  flag: "🇧🇩", name: "Bangladesh" },
  { code: "BB", dial: "+1246", flag: "🇧🇧", name: "Barbados" },
  { code: "BY", dial: "+375",  flag: "🇧🇾", name: "Belarus" },
  { code: "BE", dial: "+32",   flag: "🇧🇪", name: "Belgium" },
  { code: "BZ", dial: "+501",  flag: "🇧🇿", name: "Belize" },
  { code: "BJ", dial: "+229",  flag: "🇧🇯", name: "Benin" },
  { code: "BM", dial: "+1441", flag: "🇧🇲", name: "Bermuda" },
  { code: "BT", dial: "+975",  flag: "🇧🇹", name: "Bhutan" },
  { code: "BO", dial: "+591",  flag: "🇧🇴", name: "Bolivia" },
  { code: "BA", dial: "+387",  flag: "🇧🇦", name: "Bosnia and Herzegovina" },
  { code: "BW", dial: "+267",  flag: "🇧🇼", name: "Botswana" },
  { code: "BR", dial: "+55",   flag: "🇧🇷", name: "Brazil" },
  { code: "IO", dial: "+246",  flag: "🇮🇴", name: "British Indian Ocean Territory" },
  { code: "VG", dial: "+1284", flag: "🇻🇬", name: "British Virgin Islands" },
  { code: "BN", dial: "+673",  flag: "🇧🇳", name: "Brunei" },
  { code: "BG", dial: "+359",  flag: "🇧🇬", name: "Bulgaria" },
  { code: "BF", dial: "+226",  flag: "🇧🇫", name: "Burkina Faso" },
  { code: "BI", dial: "+257",  flag: "🇧🇮", name: "Burundi" },
  { code: "KH", dial: "+855",  flag: "🇰🇭", name: "Cambodia" },
  { code: "CM", dial: "+237",  flag: "🇨🇲", name: "Cameroon" },
  { code: "CA", dial: "+1",    flag: "🇨🇦", name: "Canada" },
  { code: "CV", dial: "+238",  flag: "🇨🇻", name: "Cape Verde" },
  { code: "KY", dial: "+1345", flag: "🇰🇾", name: "Cayman Islands" },
  { code: "CF", dial: "+236",  flag: "🇨🇫", name: "Central African Republic" },
  { code: "TD", dial: "+235",  flag: "🇹🇩", name: "Chad" },
  { code: "CL", dial: "+56",   flag: "🇨🇱", name: "Chile" },
  { code: "CN", dial: "+86",   flag: "🇨🇳", name: "China" },
  { code: "CX", dial: "+61",   flag: "🇨🇽", name: "Christmas Island" },
  { code: "CC", dial: "+61",   flag: "🇨🇨", name: "Cocos (Keeling) Islands" },
  { code: "CO", dial: "+57",   flag: "🇨🇴", name: "Colombia" },
  { code: "KM", dial: "+269",  flag: "🇰🇲", name: "Comoros" },
  { code: "CG", dial: "+242",  flag: "🇨🇬", name: "Congo" },
  { code: "CD", dial: "+243",  flag: "🇨🇩", name: "Congo (DRC)" },
  { code: "CK", dial: "+682",  flag: "🇨🇰", name: "Cook Islands" },
  { code: "CR", dial: "+506",  flag: "🇨🇷", name: "Costa Rica" },
  { code: "CI", dial: "+225",  flag: "🇨🇮", name: "Côte d'Ivoire" },
  { code: "HR", dial: "+385",  flag: "🇭🇷", name: "Croatia" },
  { code: "CU", dial: "+53",   flag: "🇨🇺", name: "Cuba" },
  { code: "CW", dial: "+599",  flag: "🇨🇼", name: "Curaçao" },
  { code: "CY", dial: "+357",  flag: "🇨🇾", name: "Cyprus" },
  { code: "CZ", dial: "+420",  flag: "🇨🇿", name: "Czech Republic" },
  { code: "DK", dial: "+45",   flag: "🇩🇰", name: "Denmark" },
  { code: "DJ", dial: "+253",  flag: "🇩🇯", name: "Djibouti" },
  { code: "DM", dial: "+1767", flag: "🇩🇲", name: "Dominica" },
  { code: "DO", dial: "+1809", flag: "🇩🇴", name: "Dominican Republic" },
  { code: "EC", dial: "+593",  flag: "🇪🇨", name: "Ecuador" },
  { code: "EG", dial: "+20",   flag: "🇪🇬", name: "Egypt" },
  { code: "SV", dial: "+503",  flag: "🇸🇻", name: "El Salvador" },
  { code: "GQ", dial: "+240",  flag: "🇬🇶", name: "Equatorial Guinea" },
  { code: "ER", dial: "+291",  flag: "🇪🇷", name: "Eritrea" },
  { code: "EE", dial: "+372",  flag: "🇪🇪", name: "Estonia" },
  { code: "SZ", dial: "+268",  flag: "🇸🇿", name: "Eswatini" },
  { code: "ET", dial: "+251",  flag: "🇪🇹", name: "Ethiopia" },
  { code: "FK", dial: "+500",  flag: "🇫🇰", name: "Falkland Islands" },
  { code: "FO", dial: "+298",  flag: "🇫🇴", name: "Faroe Islands" },
  { code: "FJ", dial: "+679",  flag: "🇫🇯", name: "Fiji" },
  { code: "FI", dial: "+358",  flag: "🇫🇮", name: "Finland" },
  { code: "FR", dial: "+33",   flag: "🇫🇷", name: "France" },
  { code: "GF", dial: "+594",  flag: "🇬🇫", name: "French Guiana" },
  { code: "PF", dial: "+689",  flag: "🇵🇫", name: "French Polynesia" },
  { code: "GA", dial: "+241",  flag: "🇬🇦", name: "Gabon" },
  { code: "GM", dial: "+220",  flag: "🇬🇲", name: "Gambia" },
  { code: "GE", dial: "+995",  flag: "🇬🇪", name: "Georgia" },
  { code: "DE", dial: "+49",   flag: "🇩🇪", name: "Germany" },
  { code: "GH", dial: "+233",  flag: "🇬🇭", name: "Ghana" },
  { code: "GI", dial: "+350",  flag: "🇬🇮", name: "Gibraltar" },
  { code: "GR", dial: "+30",   flag: "🇬🇷", name: "Greece" },
  { code: "GL", dial: "+299",  flag: "🇬🇱", name: "Greenland" },
  { code: "GD", dial: "+1473", flag: "🇬🇩", name: "Grenada" },
  { code: "GP", dial: "+590",  flag: "🇬🇵", name: "Guadeloupe" },
  { code: "GU", dial: "+1671", flag: "🇬🇺", name: "Guam" },
  { code: "GT", dial: "+502",  flag: "🇬🇹", name: "Guatemala" },
  { code: "GG", dial: "+44",   flag: "🇬🇬", name: "Guernsey" },
  { code: "GN", dial: "+224",  flag: "🇬🇳", name: "Guinea" },
  { code: "GW", dial: "+245",  flag: "🇬🇼", name: "Guinea-Bissau" },
  { code: "GY", dial: "+592",  flag: "🇬🇾", name: "Guyana" },
  { code: "HT", dial: "+509",  flag: "🇭🇹", name: "Haiti" },
  { code: "HN", dial: "+504",  flag: "🇭🇳", name: "Honduras" },
  { code: "HK", dial: "+852",  flag: "🇭🇰", name: "Hong Kong" },
  { code: "HU", dial: "+36",   flag: "🇭🇺", name: "Hungary" },
  { code: "IS", dial: "+354",  flag: "🇮🇸", name: "Iceland" },
  { code: "IN", dial: "+91",   flag: "🇮🇳", name: "India" },
  { code: "ID", dial: "+62",   flag: "🇮🇩", name: "Indonesia" },
  { code: "IR", dial: "+98",   flag: "🇮🇷", name: "Iran" },
  { code: "IQ", dial: "+964",  flag: "🇮🇶", name: "Iraq" },
  { code: "IE", dial: "+353",  flag: "🇮🇪", name: "Ireland" },
  { code: "IM", dial: "+44",   flag: "🇮🇲", name: "Isle of Man" },
  { code: "IL", dial: "+972",  flag: "🇮🇱", name: "Israel" },
  { code: "IT", dial: "+39",   flag: "🇮🇹", name: "Italy" },
  { code: "JM", dial: "+1876", flag: "🇯🇲", name: "Jamaica" },
  { code: "JP", dial: "+81",   flag: "🇯🇵", name: "Japan" },
  { code: "JE", dial: "+44",   flag: "🇯🇪", name: "Jersey" },
  { code: "JO", dial: "+962",  flag: "🇯🇴", name: "Jordan" },
  { code: "KZ", dial: "+7",    flag: "🇰🇿", name: "Kazakhstan" },
  { code: "KE", dial: "+254",  flag: "🇰🇪", name: "Kenya" },
  { code: "KI", dial: "+686",  flag: "🇰🇮", name: "Kiribati" },
  { code: "XK", dial: "+383",  flag: "🇽🇰", name: "Kosovo" },
  { code: "KW", dial: "+965",  flag: "🇰🇼", name: "Kuwait" },
  { code: "KG", dial: "+996",  flag: "🇰🇬", name: "Kyrgyzstan" },
  { code: "LA", dial: "+856",  flag: "🇱🇦", name: "Laos" },
  { code: "LV", dial: "+371",  flag: "🇱🇻", name: "Latvia" },
  { code: "LB", dial: "+961",  flag: "🇱🇧", name: "Lebanon" },
  { code: "LS", dial: "+266",  flag: "🇱🇸", name: "Lesotho" },
  { code: "LR", dial: "+231",  flag: "🇱🇷", name: "Liberia" },
  { code: "LY", dial: "+218",  flag: "🇱🇾", name: "Libya" },
  { code: "LI", dial: "+423",  flag: "🇱🇮", name: "Liechtenstein" },
  { code: "LT", dial: "+370",  flag: "🇱🇹", name: "Lithuania" },
  { code: "LU", dial: "+352",  flag: "🇱🇺", name: "Luxembourg" },
  { code: "MO", dial: "+853",  flag: "🇲🇴", name: "Macao" },
  { code: "MG", dial: "+261",  flag: "🇲🇬", name: "Madagascar" },
  { code: "MW", dial: "+265",  flag: "🇲🇼", name: "Malawi" },
  { code: "MY", dial: "+60",   flag: "🇲🇾", name: "Malaysia" },
  { code: "MV", dial: "+960",  flag: "🇲🇻", name: "Maldives" },
  { code: "ML", dial: "+223",  flag: "🇲🇱", name: "Mali" },
  { code: "MT", dial: "+356",  flag: "🇲🇹", name: "Malta" },
  { code: "MH", dial: "+692",  flag: "🇲🇭", name: "Marshall Islands" },
  { code: "MQ", dial: "+596",  flag: "🇲🇶", name: "Martinique" },
  { code: "MR", dial: "+222",  flag: "🇲🇷", name: "Mauritania" },
  { code: "MU", dial: "+230",  flag: "🇲🇺", name: "Mauritius" },
  { code: "YT", dial: "+262",  flag: "🇾🇹", name: "Mayotte" },
  { code: "MX", dial: "+52",   flag: "🇲🇽", name: "Mexico" },
  { code: "FM", dial: "+691",  flag: "🇫🇲", name: "Micronesia" },
  { code: "MD", dial: "+373",  flag: "🇲🇩", name: "Moldova" },
  { code: "MC", dial: "+377",  flag: "🇲🇨", name: "Monaco" },
  { code: "MN", dial: "+976",  flag: "🇲🇳", name: "Mongolia" },
  { code: "ME", dial: "+382",  flag: "🇲🇪", name: "Montenegro" },
  { code: "MS", dial: "+1664", flag: "🇲🇸", name: "Montserrat" },
  { code: "MA", dial: "+212",  flag: "🇲🇦", name: "Morocco" },
  { code: "MZ", dial: "+258",  flag: "🇲🇿", name: "Mozambique" },
  { code: "MM", dial: "+95",   flag: "🇲🇲", name: "Myanmar" },
  { code: "NA", dial: "+264",  flag: "🇳🇦", name: "Namibia" },
  { code: "NR", dial: "+674",  flag: "🇳🇷", name: "Nauru" },
  { code: "NP", dial: "+977",  flag: "🇳🇵", name: "Nepal" },
  { code: "NL", dial: "+31",   flag: "🇳🇱", name: "Netherlands" },
  { code: "NC", dial: "+687",  flag: "🇳🇨", name: "New Caledonia" },
  { code: "NZ", dial: "+64",   flag: "🇳🇿", name: "New Zealand" },
  { code: "NI", dial: "+505",  flag: "🇳🇮", name: "Nicaragua" },
  { code: "NE", dial: "+227",  flag: "🇳🇪", name: "Niger" },
  { code: "NG", dial: "+234",  flag: "🇳🇬", name: "Nigeria" },
  { code: "NU", dial: "+683",  flag: "🇳🇺", name: "Niue" },
  { code: "KP", dial: "+850",  flag: "🇰🇵", name: "North Korea" },
  { code: "MK", dial: "+389",  flag: "🇲🇰", name: "North Macedonia" },
  { code: "MP", dial: "+1670", flag: "🇲🇵", name: "Northern Mariana Islands" },
  { code: "NO", dial: "+47",   flag: "🇳🇴", name: "Norway" },
  { code: "OM", dial: "+968",  flag: "🇴🇲", name: "Oman" },
  { code: "PK", dial: "+92",   flag: "🇵🇰", name: "Pakistan" },
  { code: "PW", dial: "+680",  flag: "🇵🇼", name: "Palau" },
  { code: "PS", dial: "+970",  flag: "🇵🇸", name: "Palestine" },
  { code: "PA", dial: "+507",  flag: "🇵🇦", name: "Panama" },
  { code: "PG", dial: "+675",  flag: "🇵🇬", name: "Papua New Guinea" },
  { code: "PY", dial: "+595",  flag: "🇵🇾", name: "Paraguay" },
  { code: "PE", dial: "+51",   flag: "🇵🇪", name: "Peru" },
  { code: "PH", dial: "+63",   flag: "🇵🇭", name: "Philippines" },
  { code: "PL", dial: "+48",   flag: "🇵🇱", name: "Poland" },
  { code: "PT", dial: "+351",  flag: "🇵🇹", name: "Portugal" },
  { code: "PR", dial: "+1787", flag: "🇵🇷", name: "Puerto Rico" },
  { code: "QA", dial: "+974",  flag: "🇶🇦", name: "Qatar" },
  { code: "RE", dial: "+262",  flag: "🇷🇪", name: "Réunion" },
  { code: "RO", dial: "+40",   flag: "🇷🇴", name: "Romania" },
  { code: "RU", dial: "+7",    flag: "🇷🇺", name: "Russia" },
  { code: "RW", dial: "+250",  flag: "🇷🇼", name: "Rwanda" },
  { code: "BL", dial: "+590",  flag: "🇧🇱", name: "Saint Barthélemy" },
  { code: "SH", dial: "+290",  flag: "🇸🇭", name: "Saint Helena" },
  { code: "KN", dial: "+1869", flag: "🇰🇳", name: "Saint Kitts and Nevis" },
  { code: "LC", dial: "+1758", flag: "🇱🇨", name: "Saint Lucia" },
  { code: "MF", dial: "+590",  flag: "🇲🇫", name: "Saint Martin" },
  { code: "PM", dial: "+508",  flag: "🇵🇲", name: "Saint Pierre and Miquelon" },
  { code: "VC", dial: "+1784", flag: "🇻🇨", name: "Saint Vincent and the Grenadines" },
  { code: "WS", dial: "+685",  flag: "🇼🇸", name: "Samoa" },
  { code: "SM", dial: "+378",  flag: "🇸🇲", name: "San Marino" },
  { code: "ST", dial: "+239",  flag: "🇸🇹", name: "São Tomé and Príncipe" },
  { code: "SA", dial: "+966",  flag: "🇸🇦", name: "Saudi Arabia" },
  { code: "SN", dial: "+221",  flag: "🇸🇳", name: "Senegal" },
  { code: "RS", dial: "+381",  flag: "🇷🇸", name: "Serbia" },
  { code: "SC", dial: "+248",  flag: "🇸🇨", name: "Seychelles" },
  { code: "SL", dial: "+232",  flag: "🇸🇱", name: "Sierra Leone" },
  { code: "SG", dial: "+65",   flag: "🇸🇬", name: "Singapore" },
  { code: "SX", dial: "+1721", flag: "🇸🇽", name: "Sint Maarten" },
  { code: "SK", dial: "+421",  flag: "🇸🇰", name: "Slovakia" },
  { code: "SI", dial: "+386",  flag: "🇸🇮", name: "Slovenia" },
  { code: "SB", dial: "+677",  flag: "🇸🇧", name: "Solomon Islands" },
  { code: "SO", dial: "+252",  flag: "🇸🇴", name: "Somalia" },
  { code: "ZA", dial: "+27",   flag: "🇿🇦", name: "South Africa" },
  { code: "KR", dial: "+82",   flag: "🇰🇷", name: "South Korea" },
  { code: "SS", dial: "+211",  flag: "🇸🇸", name: "South Sudan" },
  { code: "ES", dial: "+34",   flag: "🇪🇸", name: "Spain" },
  { code: "LK", dial: "+94",   flag: "🇱🇰", name: "Sri Lanka" },
  { code: "SD", dial: "+249",  flag: "🇸🇩", name: "Sudan" },
  { code: "SR", dial: "+597",  flag: "🇸🇷", name: "Suriname" },
  { code: "SE", dial: "+46",   flag: "🇸🇪", name: "Sweden" },
  { code: "CH", dial: "+41",   flag: "🇨🇭", name: "Switzerland" },
  { code: "SY", dial: "+963",  flag: "🇸🇾", name: "Syria" },
  { code: "TW", dial: "+886",  flag: "🇹🇼", name: "Taiwan" },
  { code: "TJ", dial: "+992",  flag: "🇹🇯", name: "Tajikistan" },
  { code: "TZ", dial: "+255",  flag: "🇹🇿", name: "Tanzania" },
  { code: "TH", dial: "+66",   flag: "🇹🇭", name: "Thailand" },
  { code: "TL", dial: "+670",  flag: "🇹🇱", name: "Timor-Leste" },
  { code: "TG", dial: "+228",  flag: "🇹🇬", name: "Togo" },
  { code: "TK", dial: "+690",  flag: "🇹🇰", name: "Tokelau" },
  { code: "TO", dial: "+676",  flag: "🇹🇴", name: "Tonga" },
  { code: "TT", dial: "+1868", flag: "🇹🇹", name: "Trinidad and Tobago" },
  { code: "TN", dial: "+216",  flag: "🇹🇳", name: "Tunisia" },
  { code: "TR", dial: "+90",   flag: "🇹🇷", name: "Turkey" },
  { code: "TM", dial: "+993",  flag: "🇹🇲", name: "Turkmenistan" },
  { code: "TC", dial: "+1649", flag: "🇹🇨", name: "Turks and Caicos Islands" },
  { code: "TV", dial: "+688",  flag: "🇹🇻", name: "Tuvalu" },
  { code: "UG", dial: "+256",  flag: "🇺🇬", name: "Uganda" },
  { code: "UA", dial: "+380",  flag: "🇺🇦", name: "Ukraine" },
  { code: "AE", dial: "+971",  flag: "🇦🇪", name: "United Arab Emirates" },
  { code: "GB", dial: "+44",   flag: "🇬🇧", name: "United Kingdom" },
  { code: "US", dial: "+1",    flag: "🇺🇸", name: "United States" },
  { code: "UY", dial: "+598",  flag: "🇺🇾", name: "Uruguay" },
  { code: "UZ", dial: "+998",  flag: "🇺🇿", name: "Uzbekistan" },
  { code: "VU", dial: "+678",  flag: "🇻🇺", name: "Vanuatu" },
  { code: "VA", dial: "+39",   flag: "🇻🇦", name: "Vatican City" },
  { code: "VE", dial: "+58",   flag: "🇻🇪", name: "Venezuela" },
  { code: "VN", dial: "+84",   flag: "🇻🇳", name: "Vietnam" },
  { code: "VI", dial: "+1340", flag: "🇻🇮", name: "U.S. Virgin Islands" },
  { code: "WF", dial: "+681",  flag: "🇼🇫", name: "Wallis and Futuna" },
  { code: "EH", dial: "+212",  flag: "🇪🇭", name: "Western Sahara" },
  { code: "YE", dial: "+967",  flag: "🇾🇪", name: "Yemen" },
  { code: "ZM", dial: "+260",  flag: "🇿🇲", name: "Zambia" },
  { code: "ZW", dial: "+263",  flag: "🇿🇼", name: "Zimbabwe" },
];

// Quick lookup by ISO code.
export const COUNTRY_BY_CODE = Object.freeze(
  COUNTRIES.reduce((acc, c) => { acc[c.code] = c; return acc; }, {})
);

// Cricket-playing + diaspora regions surface first; rest stays alphabetical.
export const ORDERED_COUNTRIES = (() => {
  const pri = [];
  const rest = [];
  for (const c of COUNTRIES) {
    if (PRIORITY_CODES.has(c.code)) pri.push(c);
    else rest.push(c);
  }
  // Stable priority sort so India is first (matches the WhatsApp-origin user
  // base), then alphabetical within priority bucket.
  const priorityOrder = ["IN", "IE", "GB", "US", "CA", "AU", "NZ", "ZA", "AE"];
  pri.sort((a, b) => {
    const ia = priorityOrder.indexOf(a.code);
    const ib = priorityOrder.indexOf(b.code);
    if (ia !== -1 && ib !== -1) return ia - ib;
    if (ia !== -1) return -1;
    if (ib !== -1) return 1;
    return a.name.localeCompare(b.name);
  });
  return [...pri, ...rest];
})();

// Free-text search across name + dial code (case insensitive). Returns the
// priority-ordered subset that matches. Empty query → full ordered list.
export function searchCountries(query) {
  const q = (query || "").trim().toLowerCase();
  if (!q) return ORDERED_COUNTRIES;
  const stripped = q.replace(/^\+/, "");
  return ORDERED_COUNTRIES.filter((c) => {
    if (c.name.toLowerCase().includes(q)) return true;
    if (c.code.toLowerCase().includes(q)) return true;
    if (c.dial.replace("+", "").includes(stripped)) return true;
    return false;
  });
}

// XX.294 — DO NOT infer the user's country from browser locale.
// `navigator.language` is a locale, not a geolocation: a Toronto user
// on macOS "English (US)" sees `en-US` → US; an India user on
// "English (UK)" sees `en-GB` → GB. Both mislead the identity-save
// phone flow and can create wrong-country accounts. We now return
// null so the IdentitySheet requires the user to pick their own
// country explicitly.  Kept as a named export for backward-compat.
export function guessDefaultCountry() {
  return null;
}

// XX.294 — Example / expected digit range per country for the
// IdentitySheet's placeholder + client-side pre-validation.
// Kept intentionally small: only the countries we actively serve
// (cricket-playing nations + diaspora hubs from `PRIORITY_CODES`).
// Countries outside this map fall back to a generic 7-15 digit range
// (E.164 max), which is permissive on the client — the backend
// libphonenumber check remains authoritative.
export const COUNTRY_PHONE_META = Object.freeze({
  IN: { example: "98765 43210",    min: 10, max: 10 },
  GB: { example: "7700 900123",    min: 10, max: 10 },
  US: { example: "(415) 555 0123", min: 10, max: 10 },
  CA: { example: "(416) 555 0123", min: 10, max: 10 },
  AU: { example: "412 345 678",    min:  9, max:  9 },
  NZ: { example: "21 123 4567",    min:  8, max: 10 },
  ZA: { example: "82 123 4567",    min:  9, max:  9 },
  AE: { example: "50 123 4567",    min:  9, max:  9 },
  PK: { example: "301 2345678",    min: 10, max: 10 },
  LK: { example: "71 234 5678",    min:  9, max:  9 },
  BD: { example: "1712 345678",    min: 10, max: 10 },
  SG: { example: "8123 4567",      min:  8, max:  8 },
  MY: { example: "12 345 6789",    min:  9, max: 10 },
  IE: { example: "85 123 4567",    min:  9, max:  9 },
  KE: { example: "712 345678",     min:  9, max:  9 },
  NG: { example: "802 123 4567",   min: 10, max: 10 },
  NP: { example: "98 1234 5678",   min: 10, max: 10 },
});

export function phoneMetaFor(countryCode) {
  return COUNTRY_PHONE_META[countryCode]
      || { example: "Phone number", min: 7, max: 15 };
}
